export enum ScentrePredefinedSegmentTypes {
  ALWAYS_ON_TREND = 'always_on_trend',
  BELONGING = 'belonging',
  BROWSING_AS_ENTERTAINMENT = 'browsing_as_entertainment',
  CONSCIOUS_COLLECTION = 'conscious_collection',
  LIMITED_EDITION = 'limited_edition',
  QUALITY_INVESTMENT = 'quality_investment',
  SALES_SCOUT = 'sales_scout',
  SPECIFIC_NEED = 'specific_need',
}
